import { render, staticRenderFns } from "./ChatBoxModalConversationTopic.vue?vue&type=template&id=35aa0f3e&scoped=true&"
import script from "./ChatBoxModalConversationTopic.vue?vue&type=script&lang=js&"
export * from "./ChatBoxModalConversationTopic.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxModalConversationTopic.vue?vue&type=style&index=0&id=35aa0f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa0f3e",
  null
  
)

export default component.exports